const ClearType = Object.freeze({
  ALL: 'ALL',
  YEAR: 'YEAR',
  MODEL: 'MODEL',
  MANUFACTURE: 'MANUFACTURE',
});
  
export default ClearType;